module.exports = __webpack_public_path__ + "assets/img/thumb-fallback4.83e62e3b.jpg";